export enum YAxisType {
  TIME = 'time',
  IDS = 'ids',
}
